import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Block, Flex, Image, ImageWrapper } from '../../../components/common/StyledComponent/CommonStyledComponent'
import styled from 'styled-components';
import {getCardFormatText, dynamicImageUrl, resourceTypeMapping, formatEventDate, findCourseById, getSuggestionData  } from '../../../utility/utils.js';
import { postSupportClickEvent } from '../../../utility/common';
import {contentClick} from "../../../common/Analytics/GAWrapper.jsx";
const StyledAIRecommendedCard = styled(Flex)`
    transition: transform 0.2s ease;
    cursor: pointer;

    &:hover {
        transform: scale(1.02);
    }

    &:focus-visible,
    &:focus-within {
        transform: scale(1.02);
        outline: 3px solid #000000;
        outline-offset: 2px;
    }
`;

const TitleText = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const AIRecommendedCard = ({isMobile, item, askAiData}) => {
  const aisearchJsonData = useSelector((state) => state?.Aem?.aemAiSearchData) || askAiData;

  const mappedResource = resourceTypeMapping(item, aisearchJsonData ? aisearchJsonData : askAiData, window.location.origin);
  let finalLaunchUrl = mappedResource?.redirectUrl;

  if (!finalLaunchUrl && item?.launchUrl) {
    try {
      const parsedRawUrl = new URL(item.launchUrl);
      finalLaunchUrl = window.location.origin + parsedRawUrl.pathname + parsedRawUrl.search + parsedRawUrl.hash;
    } catch (e) {
      finalLaunchUrl = window.location.origin + (item.launchUrl.startsWith('/') ? '' : '/') + item.launchUrl;
    }
  }

  const newSuggestionsData = getSuggestionData();
  const ai_searchJsonData = JSON.parse(localStorage.getItem('aisearch_landingpage_data')) || {};
  const ai_suggestionData = newSuggestionsData || JSON.parse(localStorage.getItem('aisearch_suggestions_data'))?.data || {};
   
  let courseData = findCourseById(item?.id, ai_suggestionData, item, '');
  console.log('courseData12',courseData, 'image:',courseData?.resource?.imageUrl);

  const getdynamicImageUrl = dynamicImageUrl(item, courseData?.resource?.imageUrl, 'ai_recommended_resources', 'aiRecommenCsl');
  const { getFormatText } = getCardFormatText('recommonded');
  const displayFormat = getFormatText(item);
  const isInPersonEvent = item?.category?.toLowerCase() === "inperson event" || item?.category?.toLowerCase()?.includes('inperson');
   const isVirtualEvent = item?.category?.toLowerCase() === "virtual event" || item?.category?.toLowerCase()?.includes('virtual');
  const category = (item.category || '').toLowerCase();

  const categoryLabels = {
        "Recorded Event": "Event",
        "Inperson Event": "Event",
        "Quick Tips": "Quick tip",
        "Virtual Event": "Virtual event"
    };
    const courseId = item?.id;

  const courseCxAemData = useSelector((state) => {
  if (isInPersonEvent) {
    return state.Aem?.inPersonEventCxData;
  }
  if (isVirtualEvent) {
    return state.Aem?.eventCxJsonData; // Replace with your actual state key for virtual events
  }
  
  return state.Aem?.courseCxJsonData;
});
console.log('courseCxAemData',courseCxAemData);
  let courseTags = [];
  console.log('newSuggestionsData?.courses', newSuggestionsData);
  
  // 1. Fetch course tags
  for (let cItem in newSuggestionsData?.courses) {
    if (cItem === courseId) {
      console.log('Found course in newSuggestionsData.courses:', newSuggestionsData?.courses[cItem]);
      courseTags = newSuggestionsData?.courses[cItem]?.tags;
    }
  }

  // 2. Fetch event tags
  for (let eItem in newSuggestionsData?.events) {
    if (eItem === courseId) {
      courseTags = newSuggestionsData?.events[eItem]?.tags;
    }
  }
  
  // 3. Fetch in-person event tags
  for (let ipItem in newSuggestionsData?.inPersonEvents) {
    if (ipItem === courseId) {
      courseTags = newSuggestionsData?.inPersonEvents[ipItem]?.tags;
    }
  }

  // 4. NEW: Fetch Quick Tip tags from localStorage
  const isQuickTip = category.includes('quick tips') || item?.format?.toLowerCase() === 'quick tip';
  if (isQuickTip) {
    try {
      const allQuicktipsData = JSON.parse(localStorage.getItem('allQuicktipsData')) || [];
      const matchedQuickTip1 = allQuicktipsData?.find((qt) => String(qt.qtid) === String(item?.id));
      console.log('Matched QuickTip from localStorage:', matchedQuickTip1);
      if (matchedQuickTip1 && matchedQuickTip1.tags) {
        courseTags = matchedQuickTip1.tags;
        console.log('Found QuickTip tags in localStorage:', courseTags);
      }
    } catch (error) {
      console.error('Error parsing allQuicktipsData from localStorage:', error);
    }
  }

  console.log('courseCxAemData', courseCxAemData, 'courseTags', courseTags);
  
 if (courseCxAemData?.allTopics?.allTopicsData && courseTags != null) {
  let allTopicsData = [];
  let allTopicsObj = {};

  // 1. Normalize AEM topics (lowercase, remove spaces)
  courseCxAemData.allTopics.allTopicsData.forEach((aemItem) => {
    if (aemItem.value) {
      const normalizedValue = aemItem.value.toLowerCase().split(' ').join('');
      allTopicsData.push(normalizedValue);
      allTopicsObj[normalizedValue] = aemItem.label;
    }
  });
console.log('allTopicsData', allTopicsData, "allTopicsObj", allTopicsObj, "courseTags", courseTags);
  // 2. Map and match the course tags
  let matchedTags = [];
  courseTags.forEach(topic => {
    if (topic) {
      const normalizedTopic = topic.toLowerCase().split(' ').join('');
      if (allTopicsData.includes(normalizedTopic)) {
        matchedTags.push(allTopicsObj[normalizedTopic]);
        console.log('Matched topic:', topic, 'to label:', allTopicsObj[normalizedTopic]);
      }
    }
  });

  // 3. Assign the matched, correctly formatted labels back
  courseTags = matchedTags;
}

  const handleCardActivate = () => {
    if (finalLaunchUrl) {
       contentClick(
        item?.title,
        finalLaunchUrl,
        courseTags?.filter(Boolean)?.sort()?.join(', '), 
        'recommendation_details_page',
      );
      let gid = localStorage?.getItem('gptGlobalID');
      postSupportClickEvent(gid,item?.eventSerpName);
      window.open(finalLaunchUrl, '_blank');
    }
  };



return (
    <StyledAIRecommendedCard
      backgroundcolor='white'
      flexDirection="column"
      borderRadius="12px"
      tabIndex={0}
      role='link'
      onClick={handleCardActivate}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardActivate();
        }
      }}
    >
        <ImageWrapper height={isMobile ? '162px' : '206.22px'} position='relative'>
            <Image src={getdynamicImageUrl ? getdynamicImageUrl : item?.imageUrl} borderRadius="12px 12px 0 0"/>
            <Flex position='absolute' top='0' left='0' width='100%' padding='16px'>
                <Block padding='8px 12px' borderRadius='8px 0 8px 0' backgroundcolor='#fff' width='fit-content' className='vds-body-sm font-eTX-bold'> {askAiData?.resultsPageTexts?.recommendSection?.recommendTag}</Block>
            </Flex>
        </ImageWrapper>
        <Flex flexDirection='column' padding='16px' borderRadius="0 0 12px 12px" height={isMobile ? '162px' : '240px'} justifyContent='space-between'>
            <Flex flexDirection='column' gap='12px'>
                <Flex gap='6px' alignItems='center'>
                    <div className='vds-micro font-eTX-bold'> {categoryLabels[item?.category] || item?.category}</div>
                     {displayFormat != '' && 
                        <><Block borderRadius='50%' width='4px' height='4px' backgroundcolor='#000'></Block>
                        <div className='vds-micro'>{displayFormat}</div>
                      </>
                }
                </Flex>
                <TitleText className='vds-title-sm mobile-vds-title-xs'>{item?.title}</TitleText>
            </Flex>
            <Flex justifyContent='space-between' alignItems='center' gap='16px'>
                <Flex alignItems='center' gap='4px'>
                    {(isVirtualEvent || isInPersonEvent) ? (
                        item?.startDate ? (
                       <>
                           <i className='fs-4X vds-icon icon-calendar_blk color-secondary'/>
                           <div className='vds-micro font-eTX-bold color-secondary'> 
                               {formatEventDate(item.startDate)}
                           </div>
                       </>
                       ) : null
                    ) : (
                       <>
                           <i className='fs-4X vds-icon icon-timer_blk color-secondary'/>
                           <div className='vds-micro font-eTX-bold color-secondary'> 
                            {category.includes('quick tips') ? 
                            (item?.qtdt || '0 minutes')
                            : (item?.duration ? `${Math.round(item?.duration / 60)} minutes` : '0 minutes')
                            }
                            </div>
                       </>
                    )}
                </Flex>
                <i className='fs-6X sm-fs-4X vds-icon icon-right-arrow_blk pointer'
                //  onClick={() => {
                //     if (finalLaunchUrl) { 
                //       window.open(finalLaunchUrl, '_blank'); 
                //     }
                // }} 
                />
            </Flex>
        </Flex>
    </StyledAIRecommendedCard>
  )
}

export default AIRecommendedCard